// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NsTabsWrapper__container{display:flex}", ""]);
// Exports
exports.locals = {
	"container": "NsTabsWrapper__container"
};
module.exports = exports;
